import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

const borderRed = { border: '2px solid red' };

const TestComponent = () => {
  return (
    <>
      <Typography variant="h6">Section 1</Typography>
      <Grid container justifyContent="center" sx={{ flexGrow: 1, border: '1px solid green' }}>
        <Grid container sx={{ border: '1px solid red', width: '60%' }}>
          <Grid item xs={12} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
          <Grid item xs={6} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
          <Grid item xs={6} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: 3 }} variant="h6">
        Section 2
      </Typography>
      <Grid
        container
        gap={4}
        justifyContent="center"
        alignItems="center"
        item
        xs={12}
        sx={{ border: '2px solid blue' }}
      >
        <Box sx={{ padding: 8, border: '2px solid red' }}>Big box</Box>
        <Box sx={{ ...borderRed }}>Smaller Item</Box>
        <Grid item xs={6}>
          6 grid item
        </Grid>
      </Grid>

      {/* <Grid container justifyContent="center" sx={{ border: '1px solid green' }}>
        <Grid container sx={{ border: '1px solid red', width: '60%' }}>
          <Grid item xs={12} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
          <Grid item xs={6} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
          <Grid item xs={6} sx={{ border: '2px solid blue' }}>
            Grid Item
          </Grid>
        </Grid>
      </Grid> */}
    </>
  );
};

export default TestComponent;
